<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import {
    getCharacterImagePath,
    getTranslatedCharacterName,
  } from '$lib/er/character/translations';
  import type { CharacterImageType } from './consts';

  export let id: number;
  export let type: CharacterImageType;
  export let skinIndex: number;
  export let round = false;
</script>

<img
  alt={getTranslatedCharacterName($LL, id)}
  src={getCharacterImagePath(id, type, skinIndex)}
  class="character-image"
  class:round
/>

<style>
  .character-image.round {
    border-radius: var(--radius-3);
    background: var(--background);
    object-fit: contain;
  }
</style>
